(function() {
  const STORAGE_KEY = 'user_wishlist';

  // Initialize wishlist from localStorage
  window.wishlist = [];
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    const parsed = stored ? JSON.parse(stored) : [];
    window.wishlist = Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    console.error('Failed to parse user_wishlist', e);
  }

  // Toggles item in/out of array
  window.toggleWishlist = function(handle) {
    if (!handle) return;
    const index = window.wishlist.indexOf(handle);
    let added = false;
    if (index === -1) {
      window.wishlist.push(handle);
      added = true;
    } else {
      window.wishlist.splice(index, 1);
    }
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(window.wishlist));
    } catch (e) {
      console.error('Failed to save user_wishlist', e);
    }
    
    window.updateButtonStates();
    
    // Dispatch custom event for page listeners
    document.dispatchEvent(new CustomEvent('wishlist:updated', {
      detail: { items: window.wishlist, handle: handle, added: added }
    }));
  };

  // Expose backward-compatible aakrutiWishlist object
  window.aakrutiWishlist = {
    items: window.wishlist,
    load: function() { return window.wishlist; },
    toggle: function(handle) { window.toggleWishlist(handle); },
    isIn: function(handle) { return window.wishlist.includes(handle); },
    updateUI: function() { window.updateButtonStates(); }
  };

  // Updates all heart icons and badges on the page
  window.updateButtonStates = function() {
    const count = window.wishlist.length;

    // Keep wrapper items synced
    if (window.aakrutiWishlist) {
      window.aakrutiWishlist.items = window.wishlist;
    }

    // 1. Update count badges
    const badges = document.querySelectorAll('[data-totalwishlistitems]');
    badges.forEach(badge => {
      badge.textContent = count;
      if (count > 0) {
        badge.style.setProperty('display', 'flex', 'important');
        badge.style.opacity = '1';
        badge.style.visibility = 'visible';
      } else {
        badge.style.setProperty('display', 'none', 'important');
      }
    });

    // 2. Update button states and attach direct click listeners
    document.querySelectorAll('[data-wishlist-btn], .catalog-wishlist-btn').forEach(btn => {
      const handle = btn.getAttribute('data-handle') || btn.getAttribute('data-wishlist-toggle') || btn.getAttribute('data-wishlist-handle');
      if (!handle) return;
      
      // Directly attach listener to bypass any propagation stops from other scripts
      if (!btn.dataset.wishlistBound) {
        btn.dataset.wishlistBound = 'true';
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          window.toggleWishlist(handle);
        });
      }

      const isIn = window.wishlist.includes(handle);
      const icon = btn.querySelector('i');
      const textSpan = btn.querySelector('.wishlist-btn-text');

      if (isIn) {
        btn.classList.add('active');
        btn.style.color = '#c31a5c';
        if (icon) {
          icon.className = 'fa-solid fa-heart';
          icon.style.color = '#c31a5c';
        }
        if (textSpan) {
          textSpan.textContent = 'Remove from Wishlist';
        }
      } else {
        btn.classList.remove('active');
        btn.style.color = '';
        if (icon) {
          icon.className = 'fa-regular fa-heart';
          icon.style.color = '';
        }
        if (textSpan) {
          textSpan.textContent = 'Add to Wishlist';
        }
      }
    });
  };

  // Global event listener for click on any wishlist button (fallback/dynamic content)
  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-wishlist-btn], .catalog-wishlist-btn');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      const handle = btn.getAttribute('data-handle') || btn.getAttribute('data-wishlist-toggle') || btn.getAttribute('data-wishlist-handle');
      window.toggleWishlist(handle);
    }
  });

  // Periodically sync UI to handle AJAX paginations/filters safely without infinite loops
  setInterval(window.updateButtonStates, 1000);

  // Expose mock products to the window for page rendering
  window.wishlistMockProducts = [
    { handle: "peach-mul-chanderi-suit", title: "Peach Mul Chanderi Suit", price: 99900, featured_image: "https://images.unsplash.com/photo-1610030469668-93535c17b6b3?q=80&w=500", url: "#" },
    { handle: "contemporary-co-ord-set", title: "Contemporary Co-Ord Set", price: 145000, featured_image: "https://images.unsplash.com/photo-1610030469668-93535c17b6b3?q=80&w=500", url: "#" },
    { handle: "daily-comfort-lounge-wear", title: "Daily Comfort Lounge Wear", price: 129900, featured_image: "https://images.unsplash.com/photo-1610030469668-93535c17b6b3?q=80&w=500", url: "#" },
    { handle: "elegance-office-edit-gown", title: "Elegance Office Edit Gown", price: 199900, featured_image: "https://images.unsplash.com/photo-1610030469668-93535c17b6b3?q=80&w=500", url: "#" },
    { handle: "vibrant-indigo-kurta", title: "Vibrant Indigo Kurta", price: 115000, featured_image: "https://images.unsplash.com/photo-1610030469668-93535c17b6b3?q=80&w=500", url: "#" },
    { handle: "classic-red-bandhani-set", title: "Classic Red Bandhani Set", price: 219900, featured_image: "https://images.unsplash.com/photo-1610030469668-93535c17b6b3?q=80&w=500", url: "#" },
    { handle: "lush-floral-kurti-set", title: "Lush Floral Kurti Set", price: 209900, featured_image: "https://images.unsplash.com/photo-1610030469668-93535c17b6b3?q=80&w=500", url: "#" }
  ];

  // Run immediately and on DOMContentLoaded
  window.updateButtonStates();
  document.addEventListener('DOMContentLoaded', window.updateButtonStates);
})();
